import { IIdinTransaction } from '../models/idin_transaction'
import { IUser } from '../models/user'
import { BaseUrl } from './base_url_enum'
import Api, { IApiResponse } from './index'

export const createTransactionWithToken = async (
  token: string,
  email: string
) => {
  const { data } = await Api<IApiResponse<IIdinTransaction>>('POST', 'idin/create-transaction-with-token', BaseUrl.Login, {
    token,
    email
  })

  return data
}

export const requestTransactionStatusWithToken = async (
  token: string,
  email: string
) => {
  const { data } = await Api<IApiResponse<{user: IUser, token: { token: string }}>>('POST', 'idin/request-transaction-status-with-token', BaseUrl.Login, {
    token,
    email
  })

  return data
}
